<mat-dialog-content>

    <div class="grid" [style.grid-template-columns]="'repeat(' + data.table[0].length + ',  1fr)'">
        <ng-container  *ngFor="let row of data.table; let i = index; let first = first; let last = last" class="row">
            <ng-container  *ngFor="let cell of row" class="cell">
                <span *ngIf="!last && !first">{{cell}}</span>
                <span *ngIf="last || first"><strong >{{cell}}</strong></span>
                
            </ng-container>
        </ng-container>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-button mat-dialog-close tabindex="-1"><span>Schliessen</span></button>
    <button mat-raised-button mat-button (click)="saveCsv()"><span>CSV Download</span></button>
</mat-dialog-actions>